import {
  InfoItem,
  InfoItemProps,
} from 'components/molecules/InfoItem/InfoItem';
import styles from './DetailsCard.module.scss';

type TDetailsCardItem = InfoItemProps[][];

const DetailsCard = ({ items }: { items: TDetailsCardItem }) => {
  return (
    <div className={styles.container}>
      {items.map((row, rowIndex) => (
        <div key={rowIndex} className={styles.row}>
          {row.map((item, colIndex) => (
            <InfoItem
              key={colIndex}
              label={item.label}
              value={item.value}
              valueNote={item.valueNote}
              hasCopyButton={item.hasCopyButton}
              maxWidth={item.maxWidth}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default DetailsCard;
